<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 text-primary font-weight-bold">Syarat & Ketentuan Category</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Category</b>
      <br />
      <b-row class="mt-4">
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category"
            label-for="input-1"
          >
            <input
              id="input-1"
              v-model="items.name"
              v-validate="'required'"
              name="category_name_id"
              data-vv-as="Category"
              class="form-control"
              placeholder="Category"
            />
            <b-form-invalid-feedback
              id="input-category_name_id-feedback"
            >{{ veeErrors.first('category_name_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <!-- <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category (English)"
            label-for="input-1"
          >
            <input
              placeholder="Category In English"
              v-model="items.category_name.en"
              v-validate="'required'"
              data-vv-as="Category English"
              name="category_name_en"
              class="form-control"
            />
            <b-form-invalid-feedback
              id="input-category_name_en-feedback"
            >{{ veeErrors.first('category_name_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>-->
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">Save</b-button>
          <router-link :to="{name: 'FaqCategory'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      items: []
    };
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this S&K Category!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("name", this.items.name);
              // formData.append("category_name_en", this.items.category_name.en);
              this.$store
                .dispatch("TncCategoryModule/putTncCategory", {
                  id: this.$route.params.id,
                  formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "TncCategory" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.serverError = error.response.data;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      });
    }
  },
  beforeCreate() {
    this.$store.dispatch(
      "TncCategoryModule/getTncCategory",
      this.$route.params.id
    );
  },
  created() {
    this.$store.watch(
      state => state.TncCategoryModule.tnc_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  mounted() {}
};
</script>

<style>
</style>
